<script setup lang="ts">
import { useTheme } from "@/composables/useTheme";

useTheme();
</script>

<template>
  <router-view />
</template>
